<template>
  <div>
    <div
      class="chat-message-item clear"
      :class="{ self: isSelf && !isSysMessage }"
    >
      <slot name="top"></slot>

      <img
        v-if="!isSelf && !isSysMessage && !isnewChannel"
        class="avatar"
        :src="finallyUserAvatar(message)"
        @error="imgError(message)"
        alt=""
      />
      <div
        class="content-wrapper fl"
        :class="{ sys: isSysMessage, isloadele: message.isloading }"
      >
        <div
          class="name-and-time margin-bottom5"
          v-if="!isSysMessage && !isBeforeConnect && !isnewChannel"
        >
          <span class="name">{{ getMessageName(message) }}</span>
          <span class="time" v-if="message.chatTime">{{
            message.chatTime | datetime("YYYY-MM-DD HH:mm:ss")
          }}</span>
        </div>
        <div class="message-content margin-bottom5">
          <el-tooltip
            v-show="message.SENDSTATUS == 3"
            style="color: red;margin: 10px 5px 0px 0px;display: inline-block;position: absolute;left: -20px;top: 0px;"
            effect="light"
          >
            <div slot="content" style="color:red;">发送失败！点击重发</div>
            <div class="icon-item">
              <i @click="resend(message)" class="el-icon-warning-outline" />
            </div>
          </el-tooltip>
          <el-tooltip
            v-show="message.SENDSTATUS == 1"
            style="margin: 10px 5px 0px 0px;display: inline-block;position: absolute;left: -20px;top: 0px;"
            effect="light"
          >
            <div slot="content">发送中！</div>
            <div class="icon-item">
              <i class="el-icon-loading" />
            </div>
          </el-tooltip>
          <!-- 充值订单消息 -->

          <!-- 图片消息 -->
          <chatMessageImage
            class="img-message"
            v-if="isImgMessage"
            :message="message"
            :width="message.width"
            :height="message.height"
            @clickImage="clickChatMessageImage"
          />

          <!-- 文字消息 -->
          <div
            class="text-message"
            :class="!isQueue ? '' : 'isload'"
            v-else-if="isTextMessage && !isnewChannel && !isQueue"
          >
            <!-- <pre class="pre" v-html="content"></pre> -->
            <span v-for="(item, index) in httpString(content)" :key="index">
              <span v-show="!item.urls" v-text="item.str" />
              <!-- <pre class="pre" v-show="!item.urls" v-text="item.str"></pre> -->
              <a
                v-show="item.urls"
                :href="item.urls"
                target="view_window"
                style="color:dodgerblue; margin-right: 5px;"
                >{{ item.str }}</a
              >
            </span>
          </div>
          <div
            class="text-message"
            :class="!isQueue ? '' : 'isload'"
            v-else-if="isTextMessage && !isnewChannel && isQueue"
          >
            <pre class="pre" v-html="content"></pre>
          </div>
          <before-enter-page v-else-if="isBeforePage" />
          <!-- 系统消息 -->
          <span class="system-message" v-else-if="isSysMessage && content"
            >{{ content }}
            {{
              message.createTime
                ? message.createTime
                : message.chatTime | datetime("YYYY-MM-DD HH:mm:ss")
            }}</span
          >
          <!-- 银行卡加文本 -->
          <div v-else-if="isbank && isCustomer" class="text-message">
            <div>{{ message.payDetail.msgHead }}</div>
            <div>
              <label>充值方式:</label
              ><span class="itemspan">{{
                message.payDetail.rechargeType
              }}</span>
            </div>
            <div>
              <label>订单号:</label
              ><span class="itemspan">{{ message.payDetail.orderId }}</span
              ><span @click="$copyInfo(message.payDetail.orderId)" class="copy"
                >复制</span
              >
            </div>
            <div>
              <label>收款机构:</label
              ><span class="itemspan">{{ message.payDetail.rechargeBank }}</span
              ><span
                @click="$copyInfo(message.payDetail.rechargeBank)"
                class="copy"
                >复制</span
              >
            </div>
            <div>
              <label>收款账号:</label
              ><span class="itemspan">{{
                message.payDetail.receivingNumber
              }}</span
              ><span
                @click="$copyInfo(message.payDetail.receivingNumber)"
                class="copy"
                >复制</span
              >
            </div>
            <div>
              <label>收款人姓名:</label
              ><span class="itemspan">{{
                message.payDetail.receivingName
              }}</span
              ><span
                @click="$copyInfo(message.payDetail.receivingName)"
                class="copy"
                >复制</span
              >
            </div>
            <div>
              <label>付款金额(元):</label
              ><span class="itemspan">{{
                message.payDetail.paymentAmount
              }}</span
              ><span
                @click="$copyInfo(message.payDetail.paymentAmount)"
                class="copy"
                >复制</span
              >
            </div>
            <div v-if="message.payDetail.keyword">
              <label>备注:</label
              ><span class="itemspan">{{ message.payDetail.keyword }}</span
              ><span @click="$copyInfo(message.payDetail.keyword)" class="copy"
                >复制</span
              >
            </div>
          </div>
          <!-- 文本加url -->
          <div v-else-if="isUrl && isCustomer" class="text-message">
            <div>{{ message.payDetail.msgHead }}</div>
            <div>
              <label>订单号:</label
              ><span class="itemspan">{{ message.payDetail.orderId }}</span
              ><span @click="$copyInfo(message.payDetail.orderId)" class="copy"
                >复制</span
              >
            </div>
            <div>
              <label>充值方式:</label
              ><span class="itemspan">{{
                message.payDetail.rechargeType
              }}</span>
            </div>
            <div class="url">
              <a
                :href="message.payDetail.rechargeInformation"
                class="recharge"
                target="_blank"
                >查看充值信息</a
              >
            </div>
          </div>
          <!-- 数字货币 -->
          <div v-else-if="DigitalCurrency && isCustomer" class="text-message">
            <div v-html="message.payDetail.msgHead"></div>
            <div>
              <label>充值方式:</label
              ><span class="itemspan">{{
                message.payDetail.rechargeType
              }}</span>
            </div>
            <div>
              <label>充值货币:</label
              ><span class="itemspan">{{
                message.payDetail.rechargeCurrency
              }}</span>
            </div>
            <div>
              <label>充值汇率:</label
              ><span class="itemspan">{{
                message.payDetail.rechargeRate
              }}</span>
            </div>
            <div>
              <label>订单号:</label
              ><span class="itemspan">{{ message.payDetail.orderId }}</span>
            </div>
            <div>
              <label>充值金额/元:</label
              ><span class="itemspan">{{
                message.payDetail.paymentAmount
              }}</span>
            </div>
            <div>
              <label style="color:red">到帐数量:</label
              ><span style="color:red" class="itemspan">{{
                message.payDetail.paymentNumber
              }}</span>
            </div>
            <div>
              <span style="color:red"
                >{{ message.payDetail.formulaInfo }}
              </span>
            </div>
            <div>
              <label style="color:red">转账协议:</label
              ><span style="color:red" class="itemspan">{{
                message.payDetail.transferProtocol
              }}</span>
            </div>
            <div>
              <label>收款地址:</label
              ><span class="itemspan">{{
                message.payDetail.receiveAddress
              }}</span
              ><span
                @click="$copyInfo(message.payDetail.receiveAddress)"
                class="copy"
                >复制</span
              >
            </div>
            <div class="url">
              <div>收款二维码:</div>
              <chatMessageImage
                class="img-message"
                :message="message"
                :width="message.width"
                :height="message.height"
                :imgSrc="message.payDetail.rechargeInformation"
                @clickImage="clickChatMessageImage"
              />
            </div>
          </div>
          <!-- 图片加文本 -->
          <div
            v-else-if="isImgAndTextMessage && isCustomer"
            class="text-message"
          >
            <div>{{ message.payDetail.msgHead }}</div>
            <div>
              <label>充值方式:</label
              ><span class="itemspan">{{
                message.payDetail.rechargeType
              }}</span>
            </div>
            <div>
              <label>订单号:</label
              ><span class="itemspan">{{ message.payDetail.orderId }}</span
              ><span @click="$copyInfo(message.payDetail.orderId)" class="copy"
                >复制</span
              >
            </div>
            <div v-if="isImgAndTextMessage" class="paysult">
              <chatMessageImage
                class="img-message"
                :message="message"
                :width="message.width"
                :height="message.height"
                :imgSrc="message.payDetail.rechargeInformation"
                @clickImage="clickChatMessageImage"
              />
            </div>
          </div>
          <div class="text-message" v-else-if="isorder && isCustomer">
            <div>
              {{ message.payDetail.msgHead }}
            </div>
            <div>
              <label>订单号:</label
              ><span
                @click="open(message.payDetail.orderId)"
                class="copy itemspan"
                >{{ message.payDetail.orderId }}</span
              >
            </div>
            <el-dialog
              :visible.sync="drawer"
              width="50%"
              top="25vh"
              :modal="false"
              center
            >
              <div class="pannel">
                <div v-for="(item, index) in orderDetail" :key="index">
                  <label>{{ item.orderName }}</label>
                  <span>{{ item.orderValue }}</span>
                </div>
              </div>
            </el-dialog>
          </div>
          <!-- 选择订单 -->
          <div v-else-if="ischeckorder">
            <div class="text-message">
              {{ message.orderDetail.headTitle }}
            </div>
            <div
              v-if="
                message.isSelect &&
                  isConversation &&
                  customerInfo.blackFlag === 0 &&
                  message.channelId == channelId
              "
              @click.stop="checkOrder(message)"
              class="check_btn"
            >
              选择订单
            </div>
            <!-- // -->
          </div>
          <!-- 推送订单 -->
          <div v-else-if="isorderList">
            <div v-if="message.messageTemplate" class="text-message orderItem">
              <span
                v-for="(msgTemplate, index) in message.messageTemplate"
                :key="index"
              >
                <span v-if="msgTemplate.type == 101">{{
                  msgTemplate.value
                }}</span>
                <span
                  class="orderCopy copy"
                  v-if="msgTemplate.type == 201"
                  @click.stop="$copyInfo(msgTemplate.value.actionValue)"
                  >{{ msgTemplate.value.text }}</span
                >
                <div v-if="msgTemplate.type == 301"></div>
              </span>
            </div>
            <div v-if="!message.messageTemplate" class="text-message orderItem">
              <div class="text-message orderItem">
                <div>
                  {{ message.orderDetail.headTitle }}
                </div>
                <div>
                  <label style="letter-spacing:4.5px">订单号:</label
                  ><span class="itemspan"
                    >{{ message.orderDetail.orderNumber }} </span
                  ><span
                    @click.stop="$copyInfo(message.orderDetail.orderNumber)"
                    class="copy"
                    >复制</span
                  >
                </div>
                <div
                  v-if="
                    message.orderDetail.platformOrder == 3 &&
                      !message.orderDetail.rechargeType
                  "
                >
                  <label>游戏产品:</label
                  ><span class="itemspan">{{
                    message.orderDetail.channelName
                  }}</span>
                </div>
                <div v-if="message.orderDetail.platformOrder != 3">
                  <label>支付方式:</label
                  ><span class="itemspan">{{
                    message.orderDetail.rechargeType
                  }}</span>
                </div>
                <div
                  v-if="
                    message.orderDetail.platformOrder == 3 &&
                      message.orderDetail.rechargeType
                  "
                >
                  <label>游戏产品:</label
                  ><span class="itemspan">{{
                    message.orderDetail.rechargeType
                  }}</span>
                </div>

                <div>
                  <label v-if="message.orderDetail.platformOrder == 1"
                    >充值金额:</label
                  >
                  <label v-if="message.orderDetail.platformOrder == 2"
                    >提现金额:</label
                  >
                  <label v-if="message.orderDetail.platformOrder == 3"
                    >注单金额:</label
                  ><span class="itemspan">{{
                    message.orderDetail.rechargeMoney
                  }}</span>
                </div>

                <div>
                  <label>到账数量:</label
                  ><span class="itemspan">{{
                    message.orderDetail.rechargeNumber
                  }}</span>
                </div>
                <div>
                  <label>订单状态:</label>
                  <span class="itemspan">{{
                    message.orderDetail.orderStatus
                  }}</span>
                </div>
                <div
                  v-if="
                    message.orderDetail.platformOrder == 3 &&
                      message.orderDetail.orderStatus != '未结算' &&
                      message.orderDetail.win
                  "
                >
                  <label>输赢结果:</label>
                  <span class="itemspan"
                    >{{ message.orderDetail.winLose }}({{
                      message.orderDetail.win
                    }})</span
                  >
                </div>
                <div
                  v-if="
                    message.orderDetail.platformOrder == 3 &&
                      message.orderDetail.orderStatus != '未结算' &&
                      !message.orderDetail.win
                  "
                >
                  <label>输赢结果:</label>
                  <span class="itemspan">{{ message.orderDetail.result }}</span>
                </div>
                <div>
                  <label v-if="message.orderDetail.platformOrder == 1"
                    >充值账号:</label
                  >
                  <label v-if="message.orderDetail.platformOrder == 2"
                    >提现账号:</label
                  >
                  <label v-if="message.orderDetail.platformOrder == 3"
                    >注单账号:</label
                  ><span class="itemspan">
                    {{ message.orderDetail.rechargeAccount }}</span
                  >
                </div>
                <div>
                  <label>创建时间:</label
                  ><span class="itemspan">
                    {{
                      message.orderDetail.createTime
                        | customerDatetime("YYYY-MM-DD HH:mm:ss")
                    }}</span
                  >
                </div>
              </div>
            </div>
            <div
              v-if="
                message.isSelect && isshowBtn && message.channelId == channelId
              "
            >
              <el-button size="mini" @click.stop="checkOrder(message)"
                >重新选择
              </el-button>
              <el-button
                size="mini"
                @click.stop="istrue(message)"
                :loading="isBtnLoading"
                :disabled="isBtnLoading"
                type="primary"
                >是的
              </el-button>
            </div>
          </div>
          <!-- <span class="none" v-else>其他消息类型 {{ message }}</span> -->
        </div>
        <!-- <span class="none" v-else>其他消息类型 {{ message }}</span> -->
      </div>
      <!-- <div v-if="drawer" class="model"></div> -->
    </div>
  </div>
</template>

<script>
import constant from "src/constant";
import { sureOrder } from "src/app/customer/service";
import chatMessageImage from "src/app/customer/components/chat-message-image/index";
import utils from "../../utils";

export default {
  components: { chatMessageImage },
  name: "chat-message-item",
  props: {
    message: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      constant,
      srcList: [],
      drawer: false,
      isShow: true,
      isBtnLoading: false,
      serverAvatar: require("src/assets/imgs/server-avatar.jpg"),
      url:
        "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
      orderDetail: {}
    };
  },
  computed: {
    ...mapGetters(["target", "self"]),
    ...mapState({
      isBeforeConnect: state => state.isBeforeConnect,
      customerInfo: state => state.customerInfo || {},
      serverId: state => state.serverId,
      isnewChannel: state => state.isnewChannel,
      isQueue: state => state.isQueue,
      listStatus: state => state.listStatus,
      isConversation: state => state.isConversation,
      activeName: state => state.activeName,
      userId: state => state.userId,
      customerId: state => state.customerId,
      isshowBtn: state => state.isshowBtn,
      channelId: state => state.channelId
    }),
    isSelf() {
      if (utils.isCustomer()) {
        return !this.message.sendFlag;
      } else {
        return this.message.sendFlag;
      }
    },
    isTextMessage() {
      return _.get(this, "message.type") === constant.MESSAGE_TYPE.MT_TEXT;
    },
    isSysMessage() {
      return _.get(this, "message.type") === constant.MESSAGE_TYPE.MT_COMMAND;
    },
    isBeforePage() {
      return (
        _.get(this, "message.type") === constant.MESSAGE_TYPE.MT_BEFORE_ENTER
      );
    },
    isbank() {
      return _.get(this, "message.type") === constant.MESSAGE_TYPE.MT_TEXT_BANK;
    },
    isImgAndTextMessage() {
      return (
        _.get(this, "message.type") === constant.MESSAGE_TYPE.MT_TEXT_PHOTO
      );
    },
    isUrl() {
      return _.get(this, "message.type") === constant.MESSAGE_TYPE.MT_TEXT_URL;
    },
    isImgMessage() {
      return _.get(this, "message.type") === constant.MESSAGE_TYPE.MT_IMAGE;
    },
    isorder() {
      return (
        _.get(this, "message.type") === constant.MESSAGE_TYPE.MT_TEXT_ORDER
      );
    },
    DigitalCurrency() {
      return (
        _.get(this, "message.type") === constant.MESSAGE_TYPE.MT_TEXT_CURRENCY
      );
    },
    isCustomer() {
      const flag = utils.isCustomer();
      return flag;
    },
    content() {
      return _.get(this, "message.content", "");
    },
    ischeckorder() {
      return _.get(this, "message.type") === constant.MESSAGE_TYPE.MT_ORDER;
    },
    isorderList() {
      return (
        _.get(this, "message.type") === constant.MESSAGE_TYPE.MT_ORDER_CHECKED
      );
    }
  },
  methods: {
    istrue(message) {
      this.isBtnLoading = true;
      let obj = {
        channelId: message.channelId,
        serverId: this.serverId,
        clientType: 2,
        msgId: message.msgId,
        customerId: this.userId,
        userId: this.serverId,
        queryOrderType: message.orderDetail.platformOrder,
        platformOrder: message.orderDetail.orderNumber
      };
      sureOrder(obj)
        .then(res => {
          if (res.success) {
            this.message.isSelect = 0;
            this.isBtnLoading = false;
          } else {
            if (res.code == "1003") {
              this.$message.closeAll();
              this.isBtnLoading = false;
              this.$message.error("会话已结束，请重新咨询客服");
            } else {
              this.isBtnLoading = false;
              this.$message.closeAll();
              this.$message.error(res.msg);
            }
            this.message.isSelect = 1;
            this.isBtnLoading = false;
          }
        })
        .catch(() => {
          this.isBtnLoading = false;
        });
    },

    checkOrder(message) {
      this.$store.commit("setState", {
        listStatus: true,
        activeName: message.orderDetail.platformOrder.toString(),
        lastMsgId: message.msgId
      });
    },
    resend(message) {
      let needData = { ...message };
      const { orderDetail } = needData;

      needData.resendType = 1;

      if (orderDetail && orderDetail.createTime) {
        needData.type = 17;
        needData.isOrder = true;
      }

      this.$store.dispatch("chat/sendMessage", needData, { root: true });
    },

    clickChatMessageImage() {
      this.$loading = true;
      this.$emit("clickImage", this.message);
    },
    imgError(item) {
      item.serverImage = this.serverAvatar;
    },
    httpString(s) {
      let array = [];
      var reg = /((https?|http):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|])|((www|[a-zA-Z])+\.[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|])/gi;
      let str = s.match(reg);

      // 新增逻辑 2021.2.10
      if (str && str.length > 0) {
        str.forEach((item, index) => {
          let urls;
          if (item.indexOf("http") < 0) {
            urls = "https://" + item;
          } else {
            urls = item;
          }
          let strs = JSON.parse(JSON.stringify(str));
          let sS = JSON.parse(JSON.stringify(s));
          // 首字截取
          if (index == 0 && s.indexOf(item) != 0) {
            let objFirst = {
              str: sS.substring(0, sS.indexOf(item))
            };
            array.push(objFirst);
          }
          // 字符串中间
          let objMiddle = {};
          if (index < str.length - 1) {
            // 前一个
            let beforeIndex =
              this.appearNum(str, str[index], s, index) + strs[index].length;
            let afterIndex = this.appearNum(str, str[index + 1], s, index + 1);
            if (
              beforeIndex != afterIndex &&
              beforeIndex < afterIndex &&
              afterIndex > 0
            ) {
              objMiddle = {
                str: sS.substring(beforeIndex, afterIndex)
              };
              array.push(objMiddle);
            }
          }

          // 正常赋值
          let obj = {
            str: strs.splice(str.indexOf(item), item.length)[0],
            urls
          };

          if (JSON.stringify(objMiddle) != "{}") {
            array.splice(array.length - 1, 0, obj);
          }

          if (JSON.stringify(objMiddle) == "{}") {
            array.push(obj);
          }

          // 尾部
          if (index == str.length - 1) {
            let sEnd = JSON.parse(JSON.stringify(s));
            let endIndex =
              this.appearNum(str, str[index], s, index) + str[index].length;
            if (s.length > endIndex) {
              let objEnd = {
                str: sEnd.substring(endIndex, s.length)
              };
              array.push(objEnd);
            }
          }
        });
      } else {
        array.push({ str: s });
      }
      return array;
    },
    // 元素出现的位置
    appearNum(arr, str, s, number) {
      let num = 0,
        numBers = 0;
      arr.forEach((item, index) => {
        if (index <= number && item.indexOf(str) > -1) {
          num++;
        }
      });
      numBers = this.Find(s, str, num - 1);
      return numBers;
    },
    // 一个字符串值在指定字符串第n次出现的位置 参数（字符串，要查找的字符串值，要查找第几个该字符串值)
    Find(s, str, num) {
      var x = s.indexOf(str);
      for (var i = 0; i < num; i++) {
        x = s.indexOf(str, x + 1);
      }
      return x;
    },
    open(orderId) {
      this.$store.commit("setState", { isload: true });
      utils.getOrder(orderId).then(res => {
        if (res.code != 200) {
          this.$message({
            message: res.msg,
            type: "warning"
          });
        } else {
          this.drawer = true;
          this.orderDetail = res.data;
        }
        this.$store.commit("setState", { isload: false });
      });
    },
    getMessageName() {
      let name = "";
      if (
        this.message.customerName !== "" &&
        this.message.customerName !== undefined
      ) {
        name = this.message.customerName;
      } else if (utils.isCustomer()) {
        if (this.message.sendFlag) {
          name =
            this.message.serverAlias || this.message.transferServerAliasName;
          name = name ? name : this.target.serverAlias;
        } else {
          if (this.customerInfo.type == 2) {
            name = "游客";
          } else {
            name = this.self.userName;
          }
        }
      } else {
        if (this.message.sendFlag) {
          name =
            this.message.serverId == this.serverId
              ? this.self.serverAlias
              : this.message.serverAlias;
          name = name ? name : this.self.serverAlias;
        } else {
          if (this.customerInfo.type == 2) {
            name = "游客";
          } else {
            name = this.target.userName;
          }
        }
      }
      return name;
    },
    finallyUserAvatar(item) {
      if (item.customerImgUrl && item.customerName) {
        return item.customerImgUrl;
      } else if (utils.isCustomer()) {
        return item.serverImage ? item.serverImage : this.serverAvatar;
      }
    },
    getData(path = "", defaultVal = "") {
      return _.get(this, path, defaultVal);
    },
    expand(url) {
      this.srcList.push(url);
    }
  }
};
</script>
<style>
.chat-message-item .img-message {
  text-align: right;
  /* max-width: 300px; */
}

.defult {
  width: auto;
  height: auto;
}

.chat_message_image .isLoading {
  max-width: 180px !important;
  right: 0;
  height: auto;
}

.chat_message_image .isLoading p {
  font-size: 12px !important;
}

.chat_message_image .isLoading i {
  font-size: 45px;
  text-align: right;
}

.chat_message_image img {
  height: auto;
  max-width: 180px !important;
}

.load {
  padding: 6px 0;
  float: left;
  margin-right: 10px;
}

.text-lineUp {
  max-width: 56%;
  padding: 8px 10px;
  border-radius: 0 10px 10px 10px;
  background-color: #fff;
  width: fit-content;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  display: block;
  word-break: break-all;
  word-wrap: break-word;
  color: #1e1e1e;
}

.itemspan {
  margin-left: 5px;
}

.pc .text-lineUp {
  max-width: 56%;
  background: #eee;
}

.mobile .text-lineUp {
  max-width: 80%;
}

.isloadele {
  width: 100%;
  max-width: 100% !important;
}

.isloading {
  color: #b4b4b4 !important;
  width: 100%;
  font-size: 12px;
  text-align: center;
  margin: 0 auto;
}

.f_l {
  float: left;
  width: 100%;
}

.spinner {
  margin-left: 15px;
  margin-top: 15px;
}

.c_l {
  clear: both;
}

.spinner > div {
  width: 10px;
  height: 10px;
  background-color: var(--header-bg);

  border-radius: 100%;
  display: inline-block;
  -webkit-animation: bouncedelay 1.4s infinite ease-in-out;
  animation: bouncedelay 1.4s infinite ease-in-out;
  /* Prevent first frame from flickering when animation starts */
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

.spinner .bounce1 {
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}

.spinner .bounce2 {
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}

@-webkit-keyframes bouncedelay {
  0%,
  80%,
  100% {
    -webkit-transform: scale(0);
  }
  40% {
    -webkit-transform: scale(1);
  }
}

@keyframes bouncedelay {
  0%,
  80%,
  100% {
    transform: scale(0);
    -webkit-transform: scale(0);
  }
  40% {
    transform: scale(1);
    -webkit-transform: scale(1);
  }
}

.text {
  width: 88%;
}

.el-drawer__header {
  margin-bottom: 0px;
}
</style>
<style lang="less" scoped>
.check_btn {
  width: 100px;
  height: 30px;
  border: 1px solid #ccc;
  text-align: center;
  line-height: 30px;
  cursor: pointer;
  margin-top: 10px;
  border-radius: 5px;

  &:hover {
    background: var(--header-bg);
    color: #fff;
    border: 1px solid var(--header-bg);
  }
}

.avatar {
  background-color: #bcbcbc;
  border-radius: 50%;
  position: relative;

  img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }
}

.model {
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 152;
}

.copy {
  color: var(--button-bg);
  cursor: pointer;
  margin-left: 10px;
}

.pannel {
  width: 85%;
  margin: 0 auto;

  div {
    margin-top: 15px;
    border-bottom: 1px solid #ccc;
  }

  span {
    float: right;
  }
}

.paysult {
  width: 150px;
  text-align: center;
  margin: 10px 0;
}

.chat-message-item {
  margin-bottom: 5px;
  display: flex;

  &.self {
    justify-content: flex-end;

    .isloadele {
      .text-message {
        background: #c4c4c4 !important;
      }
    }

    .content-wrapper {
      .name-and-time {
        justify-content: flex-end;

        .name {
          order: 2;
          margin-right: 0;
        }

        .time {
          order: 1;
          margin-right: 10px;
        }
      }

      .message-content {
        // display: flex;
        // justify-content: flex-end;
        // align-items: flex-start;

        .text-message {
          display: block;
          word-wrap: break-word;
          // width: 100%;
          background-color: #1988ef;
          // color: #fff;
          border-radius: 10px 0 10px 10px;

          .yellow-text {
            color: var(--pre-button-help-click) !important;
          }

          .pre {
            word-break: break-all;
            text-decoration: none;
            white-space: pre-wrap;
          }
        }
      }
    }
  }

  .avatar {
    width: 30px;
    height: 30px;
    margin-right: 10px;
  }

  .content-wrapper {
    max-width: 80%;

    &.sys {
      max-width: 100%;
      width: 100%;
      text-align: center;
    }

    .name-and-time {
      display: flex;
      line-height: 20px;
      font-size: 14px;
      color: #575757;

      .name {
        margin-right: 10px;
      }
    }

    .message-content {
      .text-message {
        display: block;
        word-wrap: break-word;
        padding: 8px 10px;
        border-radius: 0 10px 10px 10px;
        font-size: 14px;
        color: #1e1e1e;
        background-color: #fff;
        line-height: 20px;

        .yellow-text {
          color: var(--pre-button-help-click) !important;
        }

        .pre {
          word-break: break-all;
          white-space: pre-wrap;
          text-decoration: none;
        }
      }

      .system-message {
        padding: 6px 12px;
        background-color: #e6e6e6;
        border-radius: 5px;
        color: #787878;
        font-size: 12px;
        display: inline-block;
        margin-bottom: 5px;
        line-height: 20px;
      }
    }
  }

  .margin-bottom5 {
    margin-bottom: 5px;
    position: relative;
  }

  .img-message {
    cursor: zoom-in;
    // max-width: 70%;
    // max-width: 20%;
    max-width: 180px;
  }

  /deep/ .hide {
    opacity: 0;
    width: 25px !important;
  }
}

.customer {
  .chat-message-item {
    .text-message {
      background-color: var(--message-accept-bg) !important;
      white-space: pre-line;
    }

    &.self {
      .text-message {
        background-color: var(--message-send-bg) !important;
        color: #000 !important;
      }
    }
  }

  // .isloadele {
  //   .isload {
  //     background: #f4f4f4 !important;
  //   }
  // }
}

.mobile {
  .img-message {
    max-width: 33%;
    // max-height: 400px;
  }
}

.url {
  text-align: center;
  padding: 10px 0;
  text-align: left;

  .recharge {
    background-color: var(--header-bg) !important;
    color: #fff !important;
    text-decoration: none;
    padding: 5px 50px;
    border-radius: 5px;
  }
}

.pc .chat-message-item .isload {
  background: transparent !important;
}
</style>
